import React from 'react';
import './index.less';

interface IFaithlifeAdProps {
	zone: string;
	params?: object;
}

interface IFaithlifeAdState {
	adContent?: string;
}

export class FaithlifeAd extends React.Component<IFaithlifeAdProps, IFaithlifeAdState> {
	state: IFaithlifeAdState = {};

	componentDidMount() {
		const { zone, params } = this.props;
		const randomNum = Math.floor(Math.random() * 99999999999);
		const callback = `handleAd${randomNum}`;

		let scriptSrc = `https://serve.faithlifeads.com/www/delivery/spc.php?zones=${zone}&r=${randomNum}&callback=${callback}&loc=${encodeURIComponent(
			window.location.toString()
		)}`;
		if (document.referrer) {
			scriptSrc += `&$referer=${encodeURIComponent(document.referrer)}`;
		}
		if (params) {
			for (const key of Object.keys(params)) {
				scriptSrc += `&${key}=${encodeURIComponent(params[key])}`;
			}
		}

		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = scriptSrc;
		document.head.appendChild(script);

		window[callback] = response => {
			this.setState({ adContent: response[zone] });
		};
	}

	render() {
		const adContent = this.state && this.state.adContent;

		return (
			<div className="faithlife-ad">
				{adContent ? (
					<div dangerouslySetInnerHTML={{ __html: adContent }} /> // eslint-disable-line react/no-danger
				) : (
					<div />
				)}
			</div>
		);
	}
}
